import { Link } from '@gusto/workbench';
import { listing as listingType } from '../proptypes/index';
import Chat from './icons/chat';
import Document from './icons/document';
import Home from './icons/home';
import MoneyBag from './icons/money_bag';
import {
  trackPartnerWebsiteClick,
  trackPartnerPricingClick,
  trackPartnerHelpClick,
  trackPartnerTermsOfServiceClick,
} from '../analytics';

const Sidebar = ({ listing }) => {
  const links = [];

  if (listing.website_url) {
    links.push({
      IconComponent: Home,
      text: listing.name,
      url: listing.website_url,
      onClick: trackPartnerWebsiteClick,
    });
  }

  if (listing.pricing_url) {
    links.push({
      IconComponent: MoneyBag,
      text: 'Pricing',
      url: listing.pricing_url,
      onClick: trackPartnerPricingClick,
    });
  }

  if (listing.help_url) {
    links.push({
      IconComponent: Chat,
      text: 'Need help?',
      url: listing.help_url,
      onClick: trackPartnerHelpClick,
    });
  }

  if (listing.terms_of_service_url) {
    links.push({
      IconComponent: Document,
      text: 'Terms of service',
      url: listing.terms_of_service_url,
      onClick: trackPartnerTermsOfServiceClick,
    });
  }

  return (
    <div>
      {links.length > 0 && (
        <div>
          <h4>Support</h4>
          <div className="links">
            {links.map(l => (
              <Link
                href={l.url}
                key={l.text}
                target="_blank"
                onClick={() => l.onClick(listing.slug)}
              >
                <l.IconComponent /> <span>{l.text}</span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

Sidebar.propTypes = {
  listing: listingType.isRequired,
};

export default Sidebar;
